export default __webpack_public_path__ + "img/bTUuvuPG.cb50a58c.svg";